import { Col } from "../../components/Styled/Container";

const NewsPage = () => {
  return <Col padding={0}>News</Col>;
};
export default NewsPage;
